import { List } from "./List";
import { Create } from "./Create";
import { Detail } from "./Detail";

export default {
  List,
  Create,
  Detail,
};
